export const MEET_IDS = {
  general: "3471360",
  support: "3471366",
  sales: "2291811",
  partnerships: "3471346",
};
